import { Check } from "lucide-react";
import { MEDIA } from "@/lib/media";
import NewsletterForm from "@/components/NewsletterForm";

const PERKS = [
  "One honest, practical email each week",
  "Strength, protein & mobility tips for women 45+",
  "The best discussions and guides from the Circle",
  "Double opt-in, no spam, unsubscribe anytime",
];

export default function Newsletter() {
  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 py-14 grid lg:grid-cols-2 gap-12 items-center">
      <div>
        <span className="font-script text-3xl text-teal">StrongKind Weekly</span>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl text-plum leading-tight">A weekly note to keep you going</h1>
        <p className="mt-4 text-mutedplum text-lg leading-relaxed">
          Join our founding readers. We share what actually helps—no hype, no fake before-and-afters, just warm, useful encouragement.
        </p>
        <ul className="mt-6 space-y-3">
          {PERKS.map((p) => (
            <li key={p} className="flex items-start gap-3 text-plum-ink/90">
              <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-teal text-white mt-0.5 shrink-0"><Check className="h-4 w-4" /></span>
              {p}
            </li>
          ))}
        </ul>
        <div className="mt-8 max-w-md"><NewsletterForm source="newsletter-page" /></div>
      </div>
      <div className="relative">
        <div className="absolute -top-6 -right-6 h-32 w-32 rounded-full bg-rose/40 -z-10" />
        <img src={MEDIA.walking} alt="Women walking together outdoors"
          className="rounded-[2rem] shadow-soft w-full h-[460px] object-cover border-4 border-white" />
      </div>
    </div>
  );
}
